var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0834 8.4915H14.675C12.7 8.4915 11.0917 6.88317 11.0917 4.90817V2.49984C11.0917 2.0415 10.7167 1.6665 10.2584 1.6665H6.72504C4.15837 1.6665 2.08337 3.33317 2.08337 6.30817V13.6915C2.08337 16.6665 4.15837 18.3332 6.72504 18.3332H13.275C15.8417 18.3332 17.9167 16.6665 17.9167 13.6915V9.32484C17.9167 8.8665 17.5417 8.4915 17.0834 8.4915ZM10.2334 13.1498L8.56671 14.8165C8.50837 14.8748 8.43337 14.9248 8.35837 14.9498C8.28337 14.9832 8.20837 14.9998 8.12504 14.9998C8.04171 14.9998 7.96671 14.9832 7.89171 14.9498C7.82504 14.9248 7.75837 14.8748 7.70837 14.8248C7.70004 14.8165 7.69171 14.8165 7.69171 14.8082L6.02504 13.1415C5.78337 12.8998 5.78337 12.4998 6.02504 12.2582C6.26671 12.0165 6.66671 12.0165 6.90837 12.2582L7.50004 12.8665V9.37484C7.50004 9.03317 7.78337 8.74984 8.12504 8.74984C8.46671 8.74984 8.75004 9.03317 8.75004 9.37484V12.8665L9.35004 12.2665C9.59171 12.0248 9.99171 12.0248 10.2334 12.2665C10.475 12.5082 10.475 12.9082 10.2334 13.1498Z",
    fill: "#F15223"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5249 7.34158C15.3166 7.34991 16.4166 7.34991 17.3583 7.34991C17.8333 7.34991 18.0833 6.79158 17.7499 6.45825C16.5499 5.24991 14.3999 3.07491 13.1666 1.84158C12.8249 1.49991 12.2333 1.73325 12.2333 2.20825V5.11658C12.2333 6.33325 13.2666 7.34158 14.5249 7.34158Z",
    fill: "#F15223"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDownload);
export default __webpack_public_path__ + "static/media/document_download.8ecb803254f16c5c0e835f5bd7fb2fa0.svg";
export { ForwardRef as ReactComponent };